import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

import template from "./quickview.vue";

import { Action } from "vuex-class";

const namespace: string = "auth";
/**
 * Quickview
 */
@Component({
  mixins: [template],
})
export default class IgaQuickview extends Vue {

  /** quick */
  @Prop() protected quick: any;

  /**
   * L'action de déconnexion
   * @type {Action}
   */
  @Action("logout", { namespace }) protected logout: any;
  /**
   * Validation de la configuration
   * @return {void}
   */
  public save(): void {
    this.quick[0].quickview.classList.remove("is-active");
    this.$snotify.success("");
  }

  /**
   * Déconnexion du user
   * @return {void}
   */
  public doLogout(): void {
    this.logout();
    this.$router.push("/auth/login");
  }

}
